import Vue from 'vue'

// axios
import axios from 'axios'


var token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImN0eSI6IkpXVCJ9.eyJqdGkiOiJlMTg0NTEyYS0xNjUxLTQ0NmItYjFiOS1jZjYzOGRhMTE4N2UiLCJuYW1laWQiOiIwM2JiOTM3NS1lOGEyLTQ1Y2MtOTBiNC0wOGRhODEyYzdkYTkiLCJ1bmlxdWVfbmFtZSI6ImFkbWluIiwibmJmIjoxNjYxNzA1Njk5LCJleHAiOjE2NjE3OTIwOTksImlzcyI6IlBBUFAgV2Vic2l0ZSIsImF1ZCI6IkFueW9uZSJ9.JBNE3uHWal3dFmfQibwRWB4XCFkh495wbJZuHAJa_4k"
export const customHeader = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: `Bearer ${token}`,
};

//const connectionString = process.env.uat-api-frontend;

const baseDonmain = `https://uat-api-marketplace-admin.azurewebsites.net`
export const baseURL = `${baseDonmain}`  

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: 'https://some-domain.com/api/',
  // timeout: 1000,
  headers: customHeader
})

Vue.prototype.$http = axiosIns

export default axiosIns
